MS = window.MS || {};

(function($) {
  MS.productlanding_content_slider = {
    selectors: {
      carousel: '.ms-pl-slider__carousel',
      slickTrack: ' .ms-pl-slider__carousel .slick-track',
      carouselContainer: '.ms-pl-slider__container',
      carouselContainerBg: '.ms-pl-slider__container__bg',
      carouselCounter: '.ms-pl-slider__carousel__counter-current',
      carouselTotal: '.ms-pl-slider__carousel__counter-total',
      arrowPrev: '.ms-pl-slider__carousel__arrows__dir.arrow-prev',
      arrowNext: '.ms-pl-slider__carousel__arrows__dir.arrow-next',
      svgMatte: '.svg-matte',
      patternId: '#pattern-id',
    },
    breakpoints: {
      mobile: 400,
      tablet: 760,
      desktop: 1200
    },
    init: function() {
      var _self = this;
      if ($('.ms-pl-slider').length === 0) return;

      _self.initSlick();
      _self.slickEvents();
      $(_self.selectors.svgMatte).css('transition', '400ms all ease');
      fillBackground(0);

      _self.updateSVGMatte();
      $(window).on(
        'resize',
        utilities.debounce(function() {
          _self.updateSVGMatte();
        }, 200)
      );
    },
    currentBreakpoint: function() {
      var _self = this;

      // determine current breakpoint
      switch (true) {
        case window.innerWidth >= _self.breakpoints.desktop:
          return 'desktop';
        case window.innerWidth >= _self.breakpoints.tablet:
          return 'tablet';
        default:
          return 'mobile';
      }
    },
    updateSVGMatte: function() {
      var _self = this;

      if (_self.currentBreakpoint() === 'mobile') {
        $(_self.selectors.patternId)[0].setAttribute('width', 1695.2 / 1.5);
        $(_self.selectors.patternId)[0].setAttribute('height', 36 / 1.5);
        return;
      }
      // tablet, desktop and beyond
      $(_self.selectors.patternId)[0].setAttribute('width', 1695.2 / 1.4);
      $(_self.selectors.patternId)[0].setAttribute('height', 36 / 1.4);
    },
    initSlick: function() {
      var _self = this;
      var settings = {
        // focusOnSelect: false,
        focusOnSelect: true,
        arrows: false,
        dots: false,
        infinite: false,
        waitForAnimate: true,
        speed: 400,
        // centerMode: true,
        // centerPadding: '15%',
        variableWidth: true,
        swipe: true,
        draggable: true,
        // slidesToShow: 1.5,
        // slidesToScroll: 0.5,
        // centerMode: true,
        swipeToSlide: true
      };

      $(_self.selectors.carousel).slick(settings);
    },
    getColor: function() {
      var _self = this;
      var $ccbg = $(_self.selectors.carouselContainerBg);
      var colors = $ccbg.data('colors').split(',');
      return colors;
    },
    slickEvents: function() {
      var _self = this;
      var sliderItemTotal = parseInt($(_self.selectors.carouselTotal).text());

      $(_self.selectors.carousel).on('beforeChange', function(
        event,
        slick,
        currentSlide,
        nextSlide
      ) {
        var offset = 45;

        if (
          window.innerWidth >= _self.breakpoints.tablet &&
          window.innerWidth < _self.breakpoints.desktop
        ) {
          offset = 90;
        }

        if (window.innerWidth >= _self.breakpoints.desktop) {
          offset = 282;
        }

        // reset offset if at the first sliderItem
        if (nextSlide === 0) {
          offset = 0;
        }

        $(_self.selectors.carouselContainer).css({
          transform: 'translate3D(' + offset + 'px, 0, 0)'
        });

        fillBackground(nextSlide);

        if (nextSlide === 0) {
          $(_self.selectors.arrowPrev).addClass('disabled');
        } else {
          $(_self.selectors.arrowPrev).removeClass('disabled');
        }

        if ((nextSlide + 1) === sliderItemTotal) {
          $(_self.selectors.arrowNext).addClass('disabled');
        } else {
          $(_self.selectors.arrowNext).removeClass('disabled');
        }

        $(_self.selectors.carouselCounter).text(nextSlide + 1);

      });

      $(_self.selectors.arrowPrev).on('click', function() {
        $(_self.selectors.carousel).slick('slickPrev');
      });

      $(_self.selectors.arrowNext).on('click', function() {
        $(_self.selectors.carousel).slick('slickNext');
      });

    }
  };

  // local util
  function fillBackground(colorIndex) {
    var _self = MS.productlanding_content_slider;
    $(_self.selectors.patternId).css('fill', _self.getColor()[colorIndex]);
    $(_self.selectors.svgMatte).css('fill', _self.getColor()[colorIndex]);
  }

})(jQuery);
